import { Accordion } from "@mantine/core";
import { L2KText } from "../Typography";
import { L2KFAQContent } from "./L2KFAQContent";
import "./faq.css";

/**
 * L2KFAQAccordion - Individual FAQ accordion item component
 *
 * Renders a single FAQ question/answer pair as an accordion item.
 * Includes proper styling, accessibility, and animations.
 *
 * @example
 * <L2KFAQAccordion
 *   value="faq-1"
 *   question="What is Learntokiz?"
 *   answer={<p>Learntokiz is a learning platform...</p>}
 * />
 */
export interface L2KFAQAccordionProps {
  /** Unique value for the accordion item */
  value: string;
  /** The question text */
  question: string;
  /** The answer content (JSX) */
  answer: React.ReactNode;
  /** Whether this item is initially expanded */
  defaultExpanded?: boolean;
}

export function L2KFAQAccordion({
  value,
  question,
  answer,
  defaultExpanded = false,
}: L2KFAQAccordionProps) {
  return (
    <Accordion.Item value={value} className="l2k-faq-accordion-item">
      <Accordion.Control className="l2k-faq-accordion-control">
        <L2KText size="sm" variant="primary" style={{ fontWeight: 600 }}>
          {question}
        </L2KText>
      </Accordion.Control>
      <Accordion.Panel className="l2k-faq-accordion-panel">
        <L2KFAQContent>{answer}</L2KFAQContent>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
